import React from "react";

import Header from "../../components/Header";
import TextInput from "../../components/Form/components/TextInput";
import LoadingSpinner from "../../components/LoadingSpinner";
import MembersApi from "../../services/portal-api/MembersApi";
import PageTitle from "../../components/PageTitle";
import withAuth from "../../services/withAuth";
import SelectInput from "../../components/Form/components/SelectInput";
import AuthService from "../../services/AuthService";
import PassTips from "../../components/HelpTip/passwordHint";
import { Redirect, Prompt, useNavigate } from "react-router-dom";
import NotFound from "../NotFound";
import CheckboxInput from "../../components/Form/components/CheckboxInput";

class EditUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                id: this.props.match.params.id,
                usid: '',
                uname: '',
                email: '',
                password: '',
                passwordRe: '',
                storeId: '',
                storeName: '',
                tmpStoreId: '',
                admin: '',
                timeoutPeriod: 0,
                secStage: '',
                tmpStage: '',
                useGlobal: false,
                resetPassword: false,
            },
            stores: [],
            isLoading: false,
            isEdited: false,
            viewSlug: null,
            usrType: '',
            errors: {}
        }
        
    }

    componentDidMount() {

        const data = this.state.data;
        const storePath = this.props.location.state.prevPath;
        const storePathId = storePath.split('/')[2];
        data.storeId = storePathId;

        this.setState({
            data: data
        }, () => {
            // this._loadListing();
            console.log(data);
        });

        // MembersApi.getUserDetails((result) => {
        //     const data = this.state.data;
        //     let usrType = this.state.usrType;

        //     if (result.success) {
        //         data['uname'] = result.json.username,
        //             data['email'] = result.json.email == null ? '' : result.json.email,
        //             data['tmpStoreId'] = data['storeId'] = result.json.store_location_id.toString(), 
        //              data['storeName'] = result.json.storename,
        //             data['admin'] = result.json.is_admin == 1 ? "super_admin" : (result.json.is_admin == 2 ? "store_admin" : (result.json.is_admin == 3 ? "cs_admin" : "user")),
        //             data['timeoutPeriod'] = result.json.timeout_period,
        //             data['useGlobal'] = result.json.is_global == 1 ? true : false;
        //         data['resetPassword'] = (result.json.sec_stage == "qa" || result.json.sec_stage == "ps") ? true : false;
        //         data['tmpStage'] = data['secStage'] = result.json.sec_stage;
        //         usrType = result.json.is_admin == 1 ? "super_admin" : (result.json.is_admin == 2 ? "store_admin" : (result.json.is_admin == 3 ? "cs_admin" : "user")),
        //             this.setState({
        //                 data: data,
        //                 usrType: usrType,
        //             });
        //     } else {
        //         if (result.status === 401) {
        //             this.props.sessionExpired();
        //             return;
        //         }
        //     }
        // }, this.props.match.params.id);

        MembersApi.fetchOneUserInStore((result) => {
            const data = this.state.data;
            let usrType = this.state.usrType;
            if(result.success) {
                data.usid = result.json.usid;
                usrType = result.json.is_admin == 1 ? "super_admin" : (result.json.is_admin == 2 ? "store_admin" : (result.json.is_admin == 3 ? "cs_admin" : "user"));
                data.uname = result.json.uname;
                data.email = result.json.email;
                data.tmpStoreId = data.storeId = result.json.store_location_id.toString();
                data.admin = result.json.is_admin == 1 ? "super_admin" : (result.json.is_admin == 2 ? "store_admin" : (result.json.is_admin == 3 ? "cs_admin" : "user"));
                data.timeoutPeriod = result.json.timeout_period;
                data.useGlobal = result.json.is_global == 1 ? true : false;
                data.resetPassword = (result.json.sec_stage == "qa" || result.json.sec_stage == "ps") ? true : false;
                data.tmpStage = data.secStage = result.json.sec_stage;
                data.storeName = result.json.storeName;

                this.setState({
                    data: data,
                    usrType: usrType,
                });
            } else {
                if (result.status === 401) {
                    this.props.sessionExpired();
                    return;
                }
            }
        }, this.props.match.params.id, storePathId);

    }

    // _loadListing() {
    //     MembersApi.getStores((result) => {

    //         if (result.success) {
    //             let stores = [];
    //             result.json.forEach((store) => {
    //                 stores.push({ key: store.id, value: store.name })
    //             })

    //             this.setState({
    //                 'stores': stores
    //             });
    //         }
    //     });
    // }

    handleInput = (event) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        const data = this.state.data;

        if (name == "timeoutPeriod") {
            data[name] = event.target.value == '' ? 0 : event.target.value;
            if (isNaN(data[name]) || data[name] < 0) {
                errors["timeoutPeriod"] = "The Inactivity Timeout needs to be a valid number greater than 0.";
            }
        } else if (name == "resetPassword") {
            data[name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
            data["secStage"] = data[name] ? (data["tmpStage"] != "sc" ? data["tmpStage"] : "qa") : "sc";

        } else if (name == "useGlobal") {
            data[name] = event.target.checked;
            data["timeoutPeriod"] = data[name] ? 0 : data["timeoutPeriod"];
            delete errors["timeoutPeriod"];

        } else {
            data[name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
            if (name == "storeId" || name == "admin") {
                data["admin"] = data["storeId"] != data['tmpStoreId'] ? "user" : data["admin"];
            }
        }

        this.setState({
            data: data,
            errors: errors,
            isEdited: true,
        }, () => { console.log("globus", this.state) });
    }

    handleSubmit = (event) => {

        // Prevent default behaviour
        event.preventDefault();

        const { admin } = this.state.data
        if (this.state.usrType != admin && admin == "store_admin" && sessionStorage.getItem('store-admins') >= 2) {
            window.scrollTo(0, 0);
            this.setState({
                viewSlug: null,
                errors: { 'admin': "The Store can't have more than 2 Store Admins" }
            });
            return;
        }

        let passwordValidDefinition =
            [
                {
                    minLength: 6,
                    ErrorMessage: "Your password must be at least six characters long.",
                },
                {
                    maxLength: 50,
                    ErrorMessage: "Your password cannot be longer than 50 characters.",
                },
                {
                    regex: /.*\d/,
                    ErrorMessage: "Your password must contain at least one digit.",
                },
                {
                    regex: /.*[a-zA-Z]/,
                    ErrorMessage: "Your password must contain at least one letter.",
                },
                {
                    regex: /.*[!@#$%^&*() =+_-]/,
                    ErrorMessage: "Your password must contain at least one symbol in this list !@#$%^&*()=+_- or a space.",
                },
            ];

        let password = this.state.data.password;
        let isvalid = true;
        const errors = this.state.errors;
        delete errors["regex"];
        delete errors["minLength"];
        delete errors["maxLength"];
        delete errors["reConfirm"];
        delete errors["admin"];
        delete errors["error"];


        if (password != this.state.data.passwordRe) {
            errors["reConfirm"] = "The confirmation password does not match or is empty."; isvalid = false;
        }

        if (password.length > 0) {
            for (let i = 0; i < passwordValidDefinition.length; i++) {
                let validator = passwordValidDefinition[i];

                if (validator.hasOwnProperty("regex")) {
                    if (password.search(validator.regex) < 0) {
                        errors["regex"] = validator.ErrorMessage;
                        isvalid = false;
                    }

                }

                if (validator.hasOwnProperty("minLength")) {
                    if (password.length < validator.minLength) {
                        errors["minLength"] = validator.ErrorMessage;
                        isvalid = false;
                    }
                }

                if (validator.hasOwnProperty("maxLength")) {
                    if (password.length > validator.maxLength) {
                        errors["maxLength"] = validator.ErrorMessage;
                        isvalid = false;
                    }
                }

            }
        }

        this.setState({
            errors: errors,
            viewSlug: null
        });

        if (!isvalid) {
            window.scrollTo(0, 0);
            return false;
        }

        if (errors["timeoutPeriod"] != undefined) {
            return false;
        }

        // Show loading and reset state
        this.setState({
            isLoading: true,
            errors: {},
        });

        let serializedInstances = [
            {
                "store": this.state.data.storeId,
                "admin": this.state.data.admin
            }
        ];

        const sendParams = {
            ...this.state.data,
            instances: JSON.stringify(serializedInstances),
        };
        

        if (!AuthService.isAdmin()) {
            delete sendParams['timeoutPeriod'];
        }

        // Fetch data
        // MembersApi.updateUser
        MembersApi.updateMultiUser(sendParams, (response) => {

            // Check for errors
            if (response.success) {
                // Redirect away
                this.setState({
                    isLoading: false,
                    isEdited: false,
                    viewSlug: response.json.message,
                });
            }
            else {
                // Check for auth
                if (response.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoading: false,
                    });
                    return;
                }

                if (response.json.errors) {
                    this.setState({
                        isLoading: false,
                        errors: response.json.errors,
                    });
                }
                else if (response.json.error) {
                    this.setState({
                        isLoading: false,
                        errors: { error: response.json.error },
                    });
                }
                else {
                    this.setState({
                        isLoading: false,
                    });
                }
            }
        });
    };

    render() {
        let c = '';
        let admins = [];
        if (this.state.viewSlug) {
            c = <div className="alert alert--success alert--outline text--center margin--20">{this.state.viewSlug}</div>
        }
        const errorsmsg = [];
        for (const [key, value] of Object.entries(this.state.errors)) {
            errorsmsg.push(<li key={key} ><span>Sorry, unable to update user: <strong>{value}</strong></span></li>);
        }
        let viewUrl = this.props.location.state == undefined ? "Not Found" : this.props.location.state.prevPath;
        let pageTitle = "Edit User";

        let { storeName } = this.state.data;

        admins = [{ key: "store_admin", value: "Store Admin" }, { key: "user", value: "Store User" }];

        if (storeName.toLowerCase().trim() == 'customer support') {
            if (AuthService.isAdmin()) {
                admins = [{ key: "super_admin", value: "Super Admin" }, {
                    key: "cs_admin",
                    value: "Customer Support Admin"
                }, { key: "user", value: "Store User" }];
            } else if (AuthService.getAdminType() == 3) {
                admins = [{
                    key: "cs_admin",
                    value: "Customer Support Admin"
                }, { key: "user", value: "Store User" }];
            }
        }

        let loaderOffset = {
            top: 200,
            position: 'absolute',
            left: '50%',
        }

        if (viewUrl == "Not Found") {

            if (AuthService.isAdmin()) {
                return (<NotFound>
                    {this.state.isLoading && <div style={{ position: 'absolute', height: '100%', width: '100%', top: 0, background: '#fff', zIndex: 7777, opacity: 0.8 }}>
                        <div className="sk-fading-circle" style={loaderOffset}>
                            <div className="sk-circle1 sk-circle" />
                            <div className="sk-circle2 sk-circle" />
                            <div className="sk-circle3 sk-circle" />
                            <div className="sk-circle4 sk-circle" />
                            <div className="sk-circle5 sk-circle" />
                            <div className="sk-circle6 sk-circle" />
                            <div className="sk-circle7 sk-circle" />
                            <div className="sk-circle8 sk-circle" />
                            <div className="sk-circle9 sk-circle" />
                            <div className="sk-circle10 sk-circle" />
                            <div className="sk-circle11 sk-circle" />
                            <div className="sk-circle12 sk-circle" />
                        </div>
                    </div>}
                </NotFound>);
            } else {
                return (<NotFound forbidden={true}><LoadingSpinner isVisible={this.state.isLoading} />
                    {this.state.isLoading && <div style={{ position: 'absolute', height: '100%', width: '100%', top: 0, background: '#fff', zIndex: 7777, opacity: 0.8 }}>
                        <div className="sk-fading-circle" style={loaderOffset}>
                            <div className="sk-circle1 sk-circle" />
                            <div className="sk-circle2 sk-circle" />
                            <div className="sk-circle3 sk-circle" />
                            <div className="sk-circle4 sk-circle" />
                            <div className="sk-circle5 sk-circle" />
                            <div className="sk-circle6 sk-circle" />
                            <div className="sk-circle7 sk-circle" />
                            <div className="sk-circle8 sk-circle" />
                            <div className="sk-circle9 sk-circle" />
                            <div className="sk-circle10 sk-circle" />
                            <div className="sk-circle11 sk-circle" />
                            <div className="sk-circle12 sk-circle" />
                        </div>
                    </div>}
                </NotFound>);
            }

        } else {

            return (<div>
                <Prompt when={this.state.isEdited} message="You have unsaved changes that will be lost. Are you sure you want to leave this page?" />
                <Header />
                <main className="content padding--80--bot" role="main">
                    <div className="container padding--60--top clearfix">

                        <header className="header--page clearfix">

                            <PageTitle back={viewUrl} title={pageTitle} />

                        </header>

                        {c}
                        {errorsmsg.length > 0 && <ul className="alert alert--outline alert--error margin--40--top">{errorsmsg}</ul>}
                        <form onSubmit={this.handleSubmit} className="margin--40--top validate loading--inline padding--90--bot" autoComplete="off">
                            <span></span>

                            <div className="col-2 gutter--40 ">
                                <div className="col">
                                    <TextInput
                                        name="uname"
                                        label="User Name"
                                        value={this.state.data.uname}
                                        error={this.state.errors.uname}
                                        onChange={this.handleInput}
                                        required={true}
                                        disabled={false}
                                    />
                                </div>
                                <div className="col">
                                    <SelectInput
                                        name="admin"
                                        label="User Type"
                                        options={admins}
                                        value={this.state.data.admin}
                                        error={this.state.errors.countryState}
                                        onChange={this.handleInput}
                                        required={true}
                                    />
                                </div>
                                <div className="col">
                                    <TextInput
                                        type="password"
                                        name="password"
                                        label="Password"
                                        value={this.state.data.password}
                                        error={this.state.errors.password}
                                        onChange={this.handleInput}
                                        required={false}
                                        tooltip={<PassTips>
                                            <ul>
                                                <li><span>Your password must be at least six characters long.</span></li>
                                                <li><span>Your password must contain at least one digit and one letter</span></li>
                                                <li><span>Your password must contain at least one symbol in this list !@#$%^&*()=+_- or a space.</span></li>
                                            </ul>
                                        </PassTips>}
                                    />
                                </div>
                                <div className="col">
                                    <TextInput
                                        type="password"
                                        name="passwordRe"
                                        label="Re-confirm Password"
                                        value={this.state.data.passwordRe}
                                        error={this.state.errors.passwordRe}
                                        onChange={this.handleInput}
                                        required={false}
                                        tooltip={<PassTips>
                                            <ul>
                                                <li><span>Your password must be at least six characters long.</span></li>
                                                <li><span>Your password must contain at least one digit and one letter</span></li>
                                                <li><span>Your password must contain at least one symbol in this list !@#$%^&*()=+_- or a space.</span></li>
                                            </ul>
                                        </PassTips>}
                                    />
                                </div>
                                
                                {AuthService.isAdmin() && <div className="col"> <div className="col-2 gutter--40 ">
                                    <div className="col">
                                        <TextInput
                                            type="text"
                                            name="timeoutPeriod"
                                            label="Inactivity Timeout (Mins)"
                                            placeholder="Enter minutes .."
                                            value={this.state.data.timeoutPeriod == 0 ? '' : this.state.data.timeoutPeriod}
                                            error={this.state.errors.timeoutPeriod}
                                            onChange={this.handleInput}
                                            required={false}
                                            disabled={this.state.data.useGlobal ? true : false}
                                        />
                                    </div>
                                    <div className="col">
                                        <CheckboxInput
                                            name="useGlobal"
                                            title=""
                                            label={"Use global timeout settings"}
                                            isChecked={this.state.data.useGlobal}
                                            onChange={this.handleInput}
                                        />
                                    </div>
                                </div></div>}
                                <div className="col">
                                    <CheckboxInput
                                        name="resetPassword"
                                        title=""
                                        label={"Change password at next login"}
                                        isChecked={this.state.data.resetPassword}
                                        onChange={this.handleInput}
                                    />
                                </div>
                                <footer className="footer--form clearfix">
                                    <div className="footer--form__left">
                                    </div>
                                    <div className="footer--form__right">
                                        <button type="submit" className="btn btn--large btn--blue">Update User</button>
                                    </div>
                                </footer>
                            </div>
                        </form>
                    </div>
                    {this.state.isLoading && <div style={{ position: 'absolute', height: '100%', width: '100%', top: 0, background: '#fff', zIndex: 7777, opacity: 0.8 }}>
                        <div className="sk-fading-circle" style={loaderOffset}>
                            <div className="sk-circle1 sk-circle" />
                            <div className="sk-circle2 sk-circle" />
                            <div className="sk-circle3 sk-circle" />
                            <div className="sk-circle4 sk-circle" />
                            <div className="sk-circle5 sk-circle" />
                            <div className="sk-circle6 sk-circle" />
                            <div className="sk-circle7 sk-circle" />
                            <div className="sk-circle8 sk-circle" />
                            <div className="sk-circle9 sk-circle" />
                            <div className="sk-circle10 sk-circle" />
                            <div className="sk-circle11 sk-circle" />
                            <div className="sk-circle12 sk-circle" />
                        </div>
                    </div>}
                </main>
            </div>);
        }
    }
}
export default withAuth(EditUser);
